import styled from "styled-components";
import {hexToRGBA} from "@dropDesk/utils/helpers/colors";

type ButtonDisabledType = {
    disable: boolean;
}

type ButtonType = {
    background: string;
    color: string;
    border: string;
    accent: string;
    width: number;
    isDarkTheme: boolean;
}

export const Container = styled.div`
  justify-content: flex-start;
  align-items: center;
  display: flex;
  flex-direction: row;
  padding: 0 16px;
  width: 100%;
  margin-bottom: 12px;
`;

export const ContainerActionButtons = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  flex-direction: row;
  padding: 5px 0;
  flex-wrap: wrap;
`;


export const ContentButton = styled.div<ButtonDisabledType>`
  display: flex;
  cursor: ${props => props.disable ? 'no-drop' : 'auto'};
  &:not(:last-of-type) {
    padding: 0 10px 0 0;
  }
`;

export const ButtonAction = styled.button<ButtonType>`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  height: 35px;
  min-height: 35px;
  width: ${props => `${props.width}px`};
  align-items: center;
  border-radius: 5px;
  font-size: 14px;
  padding: 0 8px 0 0;
  color: ${props => props.color};
  background-color: ${props => props.background};
  border: 1px solid ${props => props.border};

  &:hover {
    border-color: transparent;
    box-shadow: 0 0 0 2px ${props => hexToRGBA(props.accent, .58)};
    outline: none;
    transition: box-shadow .3s ease-out .1s, border .3s ease-out, border-radius .3s ease-out, background-color .2s ease-out, color .2s ease-out, transform .2s ease-out;
  }

  &:disabled {
    pointer-events: none;
  }
`;

export const ContainerCompactMode = styled.div`
  display: flex;
  padding: 5px 0;
`;